module.exports = "https://syscdn.233leyuan.com/233xyx-app-new/1616915989142/static/img/firstCrown.1d9fd63a.svg";